<template>
    <div>
        <div class="page">
            <SideBarShowcase :menu="menu" no-prefix></SideBarShowcase>
            <div class="page-wrapper">
                <NavbarShowcase></NavbarShowcase>
                <div class="page-content">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div v-if="overlay" class="overlay" @click="closeSideBar"></div>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import NavbarShowcase from '@/components/showcase/layout/Navbar/Navbar';
import SideBarShowcase from '@/components/showcase/layout/SideBar/SideBar';
export default {
    name: 'Showcase',
    components: { NavbarShowcase, SideBarShowcase },
    computed: {
        ...mapState('nav', ['overlay']),
        menu() {
            return [
                {
                    label: 'Home',
                    link: {
                        name: 'showcase.index',
                    },
                },
                {
                    label: 'Form Element',
                    link: {
                        name: 'showcase.form-element',
                    },
                },
                {
                    label: 'Main title',
                    link: {
                        name: 'showcase.main-title',
                    },
                },
                {
                    label: 'Sub title',
                    link: {
                        name: 'showcase.sub-title',
                    },
                },
                {
                    label: 'Modal',
                    link: {
                        name: 'showcase.modal',
                    },
                },
                {
                    label: 'Empty Data',
                    link: {
                        name: 'showcase.empty-data',
                    },
                },
                {
                    label: 'Status Item',
                    link: {
                        name: 'showcase.status-item',
                    },
                },
                {
                    label: 'Badge',
                    link: {
                        name: 'showcase.badge',
                    },
                },
                {
                    label: 'Info Tooltip',
                    link: {
                        name: 'showcase.info-tooltip',
                    },
                },
                {
                    label: 'NavTab',
                    link: {
                        name: 'showcase.nav-tab',
                    },
                },
                {
                    label: 'Tabs',
                    link: {
                        name: 'showcase.tabs',
                    },
                },
                {
                    label: 'Table Footer',
                    link: {
                        name: 'showcase.table-footer',
                    },
                },
                {
                    label: 'Simple Table',
                    link: {
                        name: 'showcase.simple-table',
                    },
                },
                {
                    label: 'Status Checkbox',
                    link: {
                        name: 'showcase.status-checkbox',
                    },
                },
                {
                    label: 'Datepicker',
                    link: {
                        name: 'showcase.datepicker',
                    },
                },
                {
                    label: 'Filter Area',
                    link: {
                        name: 'showcase.filter-area',
                    },
                },
                {
                    label: 'Toggle Confirmation',
                    link: {
                        name: 'showcase.toggle-confirm',
                    },
                },
                {
                    label: 'Simple Filter',
                    link: {
                        name: 'showcase.simple-filter',
                    },
                },
                {
                    label: 'Highlight Checkbox',
                    link: {
                        name: 'showcase.highlight-checkbox',
                    },
                },
                {
                    label: 'Search Input',
                    link: {
                        name: 'showcase.search-input',
                    },
                },
                {
                    label: 'General Info Box',
                    link: {
                        name: 'showcase.general-info-box',
                    },
                },
            ];
        },
    },
    methods: {
        closeSideBar() {
            this.$store.commit('nav/closeSidebar');
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'Showcase';
</style>
